import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { CwestiwnService } from 'src/app/craidd/gwasanaethau/system/cwestiwn.service';

@Component({
    selector: 'app-cwestiwn',
    templateUrl: './cwestiwn.component.html',
    styleUrls: ['./cwestiwn.component.scss'],
    imports: [FormlyModule]
})
export class CwestiwnComponent implements OnInit {

  @Input() public fields: FormlyFieldConfig[];
  @Input() public form: UntypedFormGroup;
  @Input() public model: any;
  @Input() public options: FormlyFormOptions;

  constructor(private cwestiwnService: CwestiwnService) { }

  ngOnInit(): void {

    this.form = this.cwestiwnService.form;
    this.options = this.cwestiwnService.options;

    if (!this.fields) {
      this.fields = this.cwestiwnService.fields;
    }
  }
}
